import React from 'react';
import Features from '../../../components/Organisms/Features'

export default function Home() {
    return (
    	<Features />
    )
}
